/**
 * Configuration object for AWS credentials and settings.
 * @property {string} aws_access_key_id - The AWS access key ID.
 * @property {string} aws_secret_access_key - The AWS secret access key.
 * @property {string} aws_region - The AWS region.
 * @property {string} aws_user_files_s3_bucket - The AWS S3 bucket for user files.
 * @property {string} aws_user_files_s3_bucket_region - The AWS region for the user files S3 bucket.
*/
// aws-exports.js
const awsConfig = {
    aws_access_key_id: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    aws_secret_access_key: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
    aws_region: process.env.REACT_APP_AWS_REGION,
    aws_user_files_s3_bucket: process.env.REACT_APP_AWS_USER_FILE_S3_BUCKET,
    aws_user_files_s3_bucket_region: process.env.REACT_APP_AWS_USER_FILE_S3_BUCKET_REGION,
  };
  
  export default awsConfig;
  